import React, { useEffect, useState } from 'react';
import { TextArea, Button, Text, Spinner, useToast } from 'components/ui';
import { useUIStore } from 'stores';
import { getTranslation } from 'i18n';
import { useSalesStore } from '../../stores/salesStore';

const CompanyProfileEditor: React.FC = () => {
  const { profile, profileLoading, fetchProfile, updateProfile } = useSalesStore();
  const language = useUIStore((s) => s.language);
  const t = (key: string) => getTranslation(language, key);
  const toast = useToast();
  const [description, setDescription] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    fetchProfile();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (profile) setDescription(profile.description);
  }, [profile]);

  const handleSave = async () => {
    setSaving(true);
    try {
      await updateProfile(description);
      toast.success(t('salesProfileToastSaved'));
    } catch {
      toast.error(t('salesProfileErrorSave'));
    } finally {
      setSaving(false);
    }
  };

  if (profileLoading && !profile) {
    return <div className="flex justify-center py-8"><Spinner /></div>;
  }

  return (
    <div>
      <Text variant="subheading" className="mb-1">{t('salesProfileTitle')}</Text>
      <p className="text-xs text-content-muted mb-4">
        {t('salesProfileDesc')}
      </p>

      <TextArea
        value={description}
        onChange={(e) => setDescription(e.target.value)}
        placeholder={t('salesProfilePlaceholder')}
        rows={8}
      />

      <div className="flex justify-end mt-3">
        <Button variant="primary" size="sm" onClick={handleSave} loading={saving}>
          {t('salesProfileBtnSave')}
        </Button>
      </div>
    </div>
  );
};

export default CompanyProfileEditor;
